import { PROMISES } from "@/content";
import { SITE } from "@/constants/testIds";
import { Reveal, SectionHead } from "./Reveal";

export const WhyUs = () => (
  <section id="perche" className="section-pad bg-white">
    <div className="container-x">
      <SectionHead index="02" eyebrow="Perché sceglierci" title="Tre promesse, semplici e trasparenti." />
      <div className="grid md:grid-cols-3 gap-6">
        {PROMISES.map((p, i) => {
          const dark = i === 1;
          return (
            <Reveal key={p.key} delay={i * 120} className="h-full">
              <article
                data-testid={SITE.promiseCard(p.key)}
                className={`h-full rounded-3xl p-8 md:p-10 transition-transform duration-300 hover:-translate-y-1 ${dark ? "bg-navy-900" : "bg-navy-50"}`}
              >
                <span className={`text-[11px] font-bold tracking-[0.22em] uppercase ${dark ? "text-bronze-300" : "text-bronze-600"}`}>{p.title}</span>
                <p className={`mt-6 text-xl md:text-[1.45rem] font-semibold leading-snug tracking-tight ${dark ? "text-white" : "text-navy-900"}`}>“{p.quote}”</p>
                <p className={`mt-6 text-[15px] leading-relaxed ${dark ? "text-navy-100" : "text-navy-500"}`}>{p.text}</p>
              </article>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
